import VariableEditForm from "./variable-edit-form";


const VariableForms = {
    Edit: VariableEditForm,
};

export default VariableForms;
